export const FIREBASE_ERROR_MESSAGES: Record<string, string> = {
  'auth/user-disabled': 'Your account has been temporarily disabled. Please try again later.',
  'auth/weak-password': 'Your password is too weak. Please use a stronger password',
  'auth/wrong-password': 'Your password is incorrect. Please try again.',
}
